import * as React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import { withTranslations } from 'helpers'
import { useLocale } from 'hooks'
import WalletPaymentButton from './WalletPaymentButton'
import type { Stripe } from '@stripe/stripe-js/types'

const WalletPayment: React.FC<WalletPaymentProps> = ({
  cart,
  currencyCode,
  isPdp = false,
  prepareForPayment,
  teardownFromPayment,
  currentStripePublishableKey,
  stripePublishableKeys,
  loadingWalletPayment = false
}) => {
  const [stripePromises, setStripePromises] = React.useState<
    { key: string; promise: Promise<Stripe | null> }[]
  >([])
  const { locale } = useLocale()

  React.useEffect(() => {
    setStripePromises(
      stripePublishableKeys.map((pubKey) => ({
        key: pubKey,
        promise: loadStripe(pubKey, { locale })
      }))
    )
  }, [locale, stripePublishableKeys])

  return stripePromises.map((promise, i) =>
    promise.key === currentStripePublishableKey ? (
      <Elements stripe={promise.promise} key={i}>
        <WalletPaymentButton
          prepareForPayment={prepareForPayment}
          teardownFromPayment={teardownFromPayment}
          isPdp={isPdp}
          cart={cart}
          currencyCode={currencyCode}
          forceLoading={loadingWalletPayment}
        />
      </Elements>
    ) : null
  )
}

interface WalletPaymentProps {
  cart: {
    ProductName: string
    ItemPrice: string
    ItemCurrency: string
  }[]
  currencyCode: string
  isPdp?: boolean
  prepareForPayment?: () => void
  teardownFromPayment?: () => void
  currentStripePublishableKey: string
  stripePublishableKeys: string[]
  loadingWalletPayment?: boolean
}

export default withTranslations(WalletPayment)
